import React, { useContext, useEffect, useState } from 'react';
import './profileSetting.css'
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../UserContext";
import translations from "../../translations";
import axios from "axios";
import api from "../../api";

const ProfileSetting = () => {
    const SERVER_URL = process.env.NODE_ENV === "development"
        ? "http://localhost:3000/api/v1/"
        : "/api/v1/";
    const { user, setUser } = useContext(UserContext);
    const navigate = useNavigate();
    const navigateBack = () => {
        navigate(`/dashboard`);
    }
    const [isEditing, setIsEditing] = useState(false);
    const [isNameEditing, setIsNameEditing] = useState(false);
    const [preferredLanguage, setPreferredLanguage] = useState(null);
    const [languages] = useState([
        { label: "English", value: "en" },
        { label: "Vietnamese", value: "vi" },
        { label: "Indonesian", value: "id" }
    ]);
    const [langOpt, setLangOpt] = useState(sessionStorage.getItem('langOpt') || 'Japanese');
    const [firstName, setFirstName] = useState(user?.firstName || "");
    const [lastName, setLastName] = useState(user?.lastName || "");
    useEffect(() => {
        if (user) {
            setPreferredLanguage(user.nativeLanguage ? user.nativeLanguage : "en");
        }
    }, [user])

    const translate = (text) => {
        if (text) {
            return langOpt === 'Japanese' ? translations[text] : text;
        } else {
            return text
        }
    };

    const saveName = async () => {
        try {
            let body = {
                firstName:firstName,
                lastName:lastName,
                userEmail: user?.userEmail,
            }
            const response = await api.put(`user/update-details`, body);
            const data = await response.json();
            console.log("Update response:", data);
            // Optionally handle response here
        } catch (error) {
            console.error("Error updating User Name:", error);
        } finally {
            setUser((prevUser) => ({
                ...prevUser,
                firstName: firstName,
                lastName: lastName,
            }));
        }
        setIsNameEditing(false); // Turn off editing mode
    };

    const saveLanguage = async () => {
        try {
            let body = {
                userEmail: user.userEmail,
                nativeLanguage: preferredLanguage
            }
            const response = await api.put(`user/update-details`, body);
            const data = await response.json();
            console.log("Update response:", data);
            // Optionally handle response here
        } catch (error) {
            console.error("Error updating language:", error);
        } finally {
            setUser((prevUser) => ({
                ...prevUser,
                nativeLanguage: preferredLanguage
            }));
        }
        setIsEditing(false); // Turn off editing mode
    };
    return (
        <>
            {/* custom container class removed */}
            <div>
                <div className="userprofileHeader">
                    <div className="header-desc" >{translate("Please review your user profile to ensure all details, including basic information and mandatory documents are accurate and complete.")}
                    </div>
                </div>
                <div className="profileDetails">
                    {/* <div className="profileDetailHeading">{translate("Basic Details")}
                    </div> */}
                    <div className="profileDetail">
                        <div className="detail">
                            <span className="detailHeading">{translate("First Name")}</span>
                            {isNameEditing ? (
                                <input
                                    type="text"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    className="detailInput"
                                />
                            ) : (
                                <span className="detailValue">{firstName || "-"}</span>
                            )}
                        </div>
                        <div className="detail">
                            <span className="detailHeading">{translate("Last Name")}</span>
                            {isNameEditing ? (
                                <input
                                    type="text"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    className="detailInput"
                                />
                            ) : (
                                <span className="detailValue">{lastName || "-"}</span>
                            )}
                        </div>
                        <div className="nameEdit">
                            {!isNameEditing ? (
                                <img
                                    src="./editProfile.svg"
                                    alt="close-button"
                                    onClick={() => setIsNameEditing(true)}
                                    style={{ cursor: "pointer" }}
                                />
                            ) : (
                                <button onClick={saveName} className="red-white-sm-btn">Save</button>
                            )}
                        </div>
                    </div>
                    <div className="profileDetail">
                        <div className="detail" style={{ "width": "100%" }}>
                            <span className="detailHeading" style={{ "display": "flex", "alignItems": "center", "gap":"50px" }} >{translate("Preferred Language")} {!isEditing ? (
                                <img
                                    className="edit-image"
                                    src="./editProfile.svg"
                                    alt="close-button"
                                    onClick={() => setIsEditing(true)}
                                    style={{ cursor: "pointer" }}
                                />
                            ) : (
                                <button onClick={saveLanguage} className="red-white-sm-btn">Save</button>
                            )}</span>
                            {!isEditing ? (
                                <span className="detailValue" style={{ "height": "25px" }}>
                                    {languages.find(lang => lang.value === preferredLanguage)?.label}</span>
                            ) : (
                                <select
                                    value={preferredLanguage}
                                    onChange={(e) => setPreferredLanguage(e.target.value)}
                                    className="language-select"
                                >
                                    {languages.map(lang => (
                                        <option key={lang.value} value={lang.value}>
                                            {lang.label}
                                        </option>
                                    ))}
                                </select>
                            )}
                        </div>
                    </div>
                    {/* <div className="profileDetailHeading">{translate("Email")}
                    </div> */}
                    <div className="profileDetail">
                        <div className="detail">
                            <span className="detailHeading">{translate("Email address")}</span>
                            <span className="detailValue">{user?.userEmail ? user?.userEmail:"-"}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProfileSetting